import { render, staticRenderFns } from "./ProductSalesPageBonus.vue?vue&type=template&id=1853f6cb&scoped=true&"
import script from "./ProductSalesPageBonus.vue?vue&type=script&lang=ts&"
export * from "./ProductSalesPageBonus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1853f6cb",
  null
  
)

export default component.exports